module.exports = __webpack_public_path__ + "img/invet_img.c7c65df6.png";